<template>
  <div class="impact-embed-links">
    <div style="background-color: #f1f1f1; vertical-align: middle;flex-direction: column;padding:2px 0px; display: flex; min-height: 100vh;justify-content: center;" v-if="this.isWidgetUserDowngrade === 'yes'">
      <div style=" display: flex; flex-direction:column;">
        <div :style="'font-family:'+ widget.font +';'">
          <div style="text-align: center; font-size: 8px;color: #000;">
            Oops! Looks like your widget has been deactivated.
            Please reactivate your B1G1 membership and get your widget running again.
          </div>
        </div>
      </div>
    </div>
    <h1 v-else class="widget-impactcounter custWorldImpactCounter" :style="'background:' + widget.bgColor + ';font-size:' + widget.size + 'px;text-align:center;color:' + widget.color + ';font-family:' + widget.font + ' !important; padding: 0; margin: 0;'">{{commafy(widget.impact)}}</h1>
  </div>
</template>

<script>
import widgetAPI from '../../api/widget'
export default {
  data () {
    return {
      widget: {
        bgColor: '#fff',
        color: '#000',
        font: 'Avenir',
        size: 40,
        impact: 0
      },
      display: {
        loaded: false
      },
      isWidgetUserDowngrade: ''
    }
  },
  methods: {
    commafy (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    loadWidgetSettings () {
      return widgetAPI.getImpactWidgetByIdNew(this.$route.params.id).then((response) => {
        this.isWidgetUserDowngrade = response.isWidgetUserDowngrade
        this.widget.bgColor = response.background_color ? response.background_color : '#fff'
        document.querySelector('body').style.backgroundColor = this.widget.bgColor
        this.widget.color = response.text_color ? response.text_color : '#000'
        this.widget.font = response.font ? response.font : 'Avenir'
        this.widget.size = response.font_size ? response.font_size : '40'
        this.widget.impact = response.impacts
      })
    }
  },
  created () {
    let widgetSettingsPromise = this.loadWidgetSettings()

    Promise.all([widgetSettingsPromise]).then(() => {
      this.display.loaded = true
      setTimeout(function () {
        document.documentElement.style.overflow = 'hidden'
      }, 1000)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/CompanyTotalImpactWidget.vue